import { render, staticRenderFns } from "./WebNotifications.vue?vue&type=template&id=2d6276ec&scoped=true"
import script from "./WebNotifications.vue?vue&type=script&lang=js"
export * from "./WebNotifications.vue?vue&type=script&lang=js"
import style0 from "./WebNotifications.vue?vue&type=style&index=0&id=2d6276ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6276ec",
  null
  
)

export default component.exports